/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Body from "../../components/Body";
import Tab from "../../components/Tab";
import useHeader from "../../hooks/useHeader";
import { observer } from "mobx-react-lite";

import InvoiceTab from "./InvoiceTab";
import RpoTab from "./RpoTab";

function BulkDownload() {
  const [activePath, setActivePath] = useState("invoice");
  const { setHeader } = useHeader();

  useEffect(() => {
    setHeader("Download");
  }, []);

  return (
    <Body>
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="d-flex" style={{ marginLeft: -50 }}>
            <Tab
              active={activePath === "invoice"}
              onClick={() => setActivePath("invoice")}
              title="Invoice"
            />
            <Tab
              active={activePath === "rpo"}
              onClick={() => setActivePath("rpo")}
              title="RPO"
            />
          </div>
        </div>
        <br />
        <div style={{ minWidth: 1200 }}>
          {activePath === "invoice" && <InvoiceTab />}
          {activePath === "rpo" && <RpoTab />}
        </div>
      </div>
    </Body>
  );
}
export default observer(BulkDownload);
